import type { PropsWithChildren } from 'react';
import { Children } from 'react';
import * as style from './LinedHeading.module.css';

export default function LinedHeading({ children }: PropsWithChildren) {
    if (!children || Children.count(children) === 0) return null;

    return <h2 className={style.linedHeading}>{children}</h2>;
}
